export { default } from './TrayMenu'



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/TrayMenu/index.js